import {
  Sparkles,
  TrendingUp,
  FileText,
  Target,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  isLimitReached: boolean;
  onSend: (question: string) => void;
}

export default function EmptyState({ isLimitReached, onSend }: EmptyStateProps) {
  const { t } = useTranslation('chat');

  const exampleQuestions = [
    {
      icon: TrendingUp,
      title: t('emptyState.example.promotion.title'),
      question: t('emptyState.example.promotion.question'),
    },
    {
      icon: FileText,
      title: t('emptyState.example.content.title'),
      question: t('emptyState.example.content.question'),
    },
    {
      icon: Target,
      title: t('emptyState.example.audience.title'),
      question: t('emptyState.example.audience.question'),
    },
    {
      icon: Sparkles,
      title: t('emptyState.example.ideas.title'),
      question: t('emptyState.example.ideas.question'),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full max-w-2xl mx-auto px-8 py-4">
      <div className="text-center mb-8">
        <h2 className="font-manrope font-bold text-[32px] leading-[40px] text-[color:var(--black-text,#0d0d0d)] mb-2">
          {t('emptyState.title')}
        </h2>
        <p className="font-segoe text-[16px] leading-[24px] text-[color:var(--grey-text,#565858)]">
          {t('emptyState.subtitle')}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px] w-full">
        {exampleQuestions.map((item, index) => (
          <button
            key={index}
            onClick={() => onSend(item.question)}
            disabled={isLimitReached}
            className={cn(
              'flex items-start gap-[16px] p-[16px] rounded-[16px] border border-[var(--grey-accent,#eeeeee)] text-left transition-all',
              isLimitReached
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:border-[var(--main-brand,#2197f1)] hover:bg-[var(--accent-background,rgba(33,151,241,0.1))]'
            )}
          >
            <item.icon className="h-5 w-5 text-[var(--main-brand,#2197f1)] mt-0.5 flex-shrink-0" />
            <div>
              <p className="font-manrope font-semibold text-[14px] leading-[20px] text-[color:var(--black-text,#0d0d0d)]">{item.title}</p>
              <p className="font-segoe text-[14px] leading-[20px] text-[color:var(--grey-text,#565858)] mt-0.5">{item.question}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
